import InternalUsers from './InternalUsers';

export default InternalUsers;
